import Vue from 'vue';
import download from 'utils/download';

export default () => {
  Vue.use((v) => {
    v.download = download;
    v.prototype.$download = download;
  });
};
